<!--答案-->
<template>
  <div>
    <div class="answer" v-if="answerPop">
      <div class="answer-content">
        <div class="inner">
          <img class="answerbg" :src="currentCardInfo.icon" alt="" />
        </div>

        <van-field
          @input="getInpValue"
          v-model.trim="exchangeCard"
          type="input"
          placeholder="请填写完整单词（包含首字母）"
        />
        <div class="tmallBtn" @click="onClickTmall">提交</div>
      </div>
    </div>
    <!-- 正确 -->
    <ResultPop ref="lotteryResult" :adrdetail="this.adrdetail"></ResultPop>
    <!-- 错误 -->
    <WrongPop ref="lotteryWrong"></WrongPop>
  </div>
</template>

<script>
import ResultPop from './resultPop.vue';
import WrongPop from './wrongPop.vue';
import { reqWordverifyUrl } from '@/api/activity/index';

export default {
  components: {ResultPop,WrongPop},
  data() {
    return {
      answerPop: false,
      exchangeCard: '',
      selected: -1,
    };
  },
  props: {
    currentCardInfo: {
      type: Object,
      default: () => ({}),
    },
    adrdetail: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {
    getInpValue() {
      if (this.exchangeCard) {
        this.selected = 0;
      } else {
        this.selected = -1;
      }
    },
    async onClickTmall() {
      if (this.selected === -1) {
        this.$toast('请输入单词');
        return;
      }
      const res = await reqWordverifyUrl({
        recordId: this.currentCardInfo.recordId,
        word: this.exchangeCard,
      });
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      if (res.code === 0) {
        if(res.data){
          this.answerPop = false;
          this.$refs.lotteryResult.resultPop = true;
        }else{
          this.answerPop = false;
          this.$refs.lotteryWrong.wrongPop = true;
        }
      } else {
        this.$toast('首字母填写错误，请重新输入');
      }
      this.exchangeCard = '';
      this.selected = -1;
      setTimeout(() => {
        this.$toast.clear();
      }, 1000);

    },
  },
};
</script>
<style lang="scss" scoped>
.answer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.8);
  .answer-content {
    position: relative;
    top: 50%;
    width: 574px;
    margin: 0 auto;
    top: 47%;
    transform: translateY(-50%);
    .inner {
      height: 622px;
      padding-top: 1px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/questionlottery/answerbg.png')
        no-repeat center;
      background-size: 100% 100%;
    }
    .answerbg {
      display: block;
      width: 332px;
      height: 415px;
      margin: 140px auto 0;
      animation: rotateAndScale 0.5s linear;
    }
  }
  .tmallBtn {
    width: 260px;
    height: 80px;
    margin: 60px auto 0;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    line-height: 80px;
    text-align: center;
    background: linear-gradient(180deg, #ff6e75 0%, #ff216e 100%);
    border-radius: 40px;
  }

  ::v-deep .van-popup {
    background-color: transparent !important;
  }
  ::v-deep {
    .van-cell {
      padding: 0;
      background-color: transparent;
      .van-field__body {
        .van-field__control {
          height: 60px;
          color: #ff3075;
          font-weight: 400;
          font-size: 24px;
          font-weight: bold;
          color: #ff3075;
          text-align: center;
          background: #ffd6da;
          border: 3px solid #fff;
          border-radius: 8px;
        }
        input::-webkit-input-placeholder {
          color: #ff3075;
          font-size: 17px;
        }
      }
    }
  }
}

@keyframes rotateAndScale {
  0% {
    transform: rotate(0deg) scale(0.5); /* 开始时，旋转0度，缩放比例0.5 */
  }
  100% {
    transform: rotate(360deg) scale(1); /* 结束时，旋转360度，缩放比例1 */
  }
}
</style>
